import { Flex } from "@chakra-ui/react";

import type { DTO } from "@equidefi/shared/types";
import { Heading, Paper, Text } from "@equidefi/ui";
import { UploadVaultUrlComponent } from "./UploadComponent";

export const ProofOfAddress: React.FC<{
  isTerminated?: boolean;
  vault: DTO.Vault;
  investmentId: string;
  refetch: () => Promise<void> | void;
}> = ({ vault, isTerminated = false, investmentId, refetch }) => {
  return (
    <form onSubmit={() => {}}>
      <Paper my={4} p={4}>
        <Flex align="left" gap="1" direction="column">
          <Heading fontWeight="bold" m="0">
            Proof Of Address
          </Heading>
          <Text mb="4">You must upload a proof of address document, such as utility bill.</Text>
        </Flex>
        {!isTerminated ? (
          <UploadVaultUrlComponent
            title="Your Proof Of Address Document"
            investmentId={investmentId}
            onUpload={() => refetch()}
            onDelete={() => refetch()}
            vault={vault}
            fieldName="Proof of Address"
            field="utility_bill"
            noDocumentWarning="You must upload a proof of address document."
          />
        ) : (
          <Text mb={0} color="gray.500" fontStyle="italic">
            Document uploads are disabled for terminated offerings.
          </Text>
        )}
      </Paper>
    </form>
  );
};
